export const updateDesignV2Api = (data: IDesignV2APIFlags) => {
  if (!window.DesignV2API) return

  window.DesignV2API.init(data)
}
